import React, { useEffect } from 'react'
import './Document.css'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import DocumentWindow from '../../component/document/DocumentWindow'
import DocumentDetails from '../../component/document/DocumentDetails'
import RejectDocument from '../../component/document/RejectDocument'
import Spinner from '../../utilities/spinner/Spinner'
//Bootstrap
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from 'react-bootstrap/Button'
//Redux
import { getDirectDocument, getReadyDocument, setTitle } from '../../redux'
import { useSelector, useDispatch } from 'react-redux'

function ViewDocumentDetails() {
  const dispatch = useDispatch()
  const { documentId } = useParams()
  const history = useHistory()
  const user = useSelector((state) => state.user)
  const myDocument = useSelector((state) => state.document)
  const ui = useSelector((state) => state.ui)

  useEffect(() => {
    dispatch(setTitle('View Document'))
  }, [])
  useEffect(() => {
    if (myDocument.documents.findIndex((doc) => doc.id === documentId) >= 0) {
      dispatch(getReadyDocument(documentId))
    } else {
      dispatch(getDirectDocument(documentId))
    }
  }, [documentId])

  const downloadFile = (url) => {
    var link = document.createElement('a')
    if (link.download !== undefined) {
      link.setAttribute('href', url)
      link.setAttribute('target', '_blank')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const isSigned = (receiver) => receiver.id === user.credentials.id && receiver.signedAt

  let signerSectionMarkup =
    user.credentials.role === 'Signer' && myDocument.document && myDocument.document.status === 'Pending' ? (
      myDocument.document.receivers.some(isSigned) ? (
        <h5 className='signed-text'>You signed the document already.</h5>
      ) : (
        <div>
          <Button variant='success' onClick={() => history.push('/signDocumentModal/' + documentId)}>
            Sign Document
          </Button>
          <RejectDocument documentId={documentId} loading={ui.loading} rejecterName={user.credentials.name} />
        </div>
      )
    ) : null

  let detailMarkup = !myDocument.loading ? (
    myDocument.document && !myDocument.notFound ? (
      <div className='document-container'>
        <div className='window-style'>
          {/* <DocumentWindow file={file} /> */}
          <DocumentWindow file={myDocument.document.originalDoc.url} />
        </div>
        <div className='form-style'>
          <DocumentDetails targetedDocument={myDocument.document} />
          {signerSectionMarkup}

          <div className='download-button-container'>
            <DropdownButton as={ButtonGroup} title='Download' id='bg-nested-dropdown' variant='outline-primary'>
              <Dropdown.Item eventKey='1' onClick={() => downloadFile(myDocument.document.originalDoc.url)}>
                Original Copy
              </Dropdown.Item>
              {myDocument.document.signedDoc && (
                <Dropdown.Item eventKey='2' onClick={() => downloadFile(myDocument.document.signedDoc.url)}>
                  Signed Copy
                </Dropdown.Item>
              )}
            </DropdownButton>
            <Button
              className='button-style'
              variant='dark'
              onClick={() => {
                history.goBack()
              }}
            >
              Back
            </Button>
          </div>
        </div>
      </div>
    ) : (
      <p>No Such Document</p>
    )
  ) : (
    <Spinner />
  )

  return detailMarkup
}

export default ViewDocumentDetails
